export default __webpack_public_path__ + "static/media/Numbers_10.54a27492.png";